import React from "react";
import Nav from 'react-bootstrap/Nav';
import {useRouter} from 'util/router'

function ClassWidgetNav({selectedIndex, url}) {

    const router = useRouter()

    function stripTrailingSlash(str) {
        if(str.substr(-1) === '/') {
            return str.substr(0, str.length - 1);
        }
        return str;
    }

    url = stripTrailingSlash(url)

    // let { path, url } = useRouteMatch();
    return (
        <>
        <Nav id="checkoutNav" className="d-flex flex-row justify-content-between mx-1 mt-3">
            <Nav.Item>
                <Nav.Link
                onClick={() => router.push(url)}
                eventKey={0}
                className={selectedIndex == 0 ? "selected primaryColor pl-0" : "primaryColor pl-0"}
                >
                    SCHEDULE
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link 
                eventKey={selectedIndex < 1 ? "disabled" : 1}
                className={selectedIndex == 1 ? "selected primaryColor pl-0" : "disabled primaryColor pl-0"}
                >
                    DETAILS
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link 
                eventKey={selectedIndex < 2 ? "disabled" : 2}
                className={selectedIndex == 2 ? "selected primaryColor pl-0" : "disabled primaryColor px-0"}
                >
                    CONFIRM
                </Nav.Link>
            </Nav.Item>
        </Nav>
    </>
    )
}

export default ClassWidgetNav
